module.exports = __webpack_public_path__ + "static/session-0b34c7b0ead02d2d9dba72fb78310568.jpg";